module.exports = __webpack_public_path__ + "img/9788958282594.7ebd7a5a.jpg";